import { render, staticRenderFns } from "./DataReportOweDetailStatistics.vue?vue&type=template&id=cd252b4a&scoped=true"
import script from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportOweDetailStatistics.vue?vue&type=style&index=0&id=cd252b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd252b4a",
  null
  
)

export default component.exports